import React from 'react';
import './WhatWeDo.css';

const WhatWeDo = () => {
  return (
    <div><p>WhatWeDo</p></div>
  )
}

export default WhatWeDo;